import { createPutAsyncSlice } from '@sonar-software/xuder';
import { getCoreBusinessContextSlice } from './get';
import { putBusinessContext } from '@api';

export const putCoreBusinessContextSlice = createPutAsyncSlice({
	httpSagaOptions: {
		successActionCreators: [ getCoreBusinessContextSlice.asyncActionCreators.requestGetCoreBusinessContext ]
	},
	name: 'CoreBusinessContext',
	receive: false,
	request: true,
	requestHandler: putBusinessContext
});
